export default __webpack_public_path__ + "static/media/a011-example5.ccb615f7.jpg";